import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Gift, MessageSquare, Sparkles, Shield } from "lucide-react";

export default function Pricing() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14" data-testid="pricing-page">
      <div className="text-center mb-10">
        <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100 font-mono-tech uppercase tracking-wider text-[11px]">
          <Gift className="w-3 h-3 mr-1.5" /> Beta gratuite
        </Badge>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[#0F2137] mt-4">
          Logiciel de planning chantier gratuit
        </h1>
        <p className="text-slate-600 mt-3 max-w-xl mx-auto">
          Le seul logiciel de planning chantier en ligne qui génère un diagramme de Gantt depuis votre devis PDF. Actuellement en phase de test — utilisez-le gratuitement en échange de votre retour.
        </p>
      </div>

      <div className="rounded-2xl bg-[#0F2137] text-white p-8 sm:p-10 ring-2 ring-[#F59E0B] shadow-xl" data-testid="beta-plan">
        <div className="flex items-baseline gap-2">
          <span className="font-display text-6xl font-extrabold text-white">0 €</span>
          <span className="text-slate-300 text-sm">/ planning</span>
        </div>
        <p className="text-slate-300 text-sm mt-2">
          Pas de carte bancaire. Pas d'engagement. Un simple retour d'expérience à la fin.
        </p>
        <ul className="mt-7 space-y-2.5 text-sm">
          {[
            "Accès complet au logiciel",
            "Analyse du devis",
            "Diagramme de Gantt interactif + édition manuelle",
            "Filtres corps d'état + chemin critique + alertes retard",
            "Export PDF & CSV du planning",
            "Historique des plannings illimité",
          ].map((f, i) => (
            <li key={i} className="flex items-start gap-2">
              <Sparkles className="w-4 h-4 mt-0.5 shrink-0 text-[#F59E0B]" />
              <span className="text-slate-100">{f}</span>
            </li>
          ))}
        </ul>
        <Link to="/nouveau" data-testid="cta-start-free">
          <Button className="mt-8 w-full h-12 font-semibold bg-[#F59E0B] hover:bg-[#D97706] text-[#0F2137] text-base">
            Générer mon planning gratuitement
          </Button>
        </Link>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        <div className="rounded-xl border border-slate-200 bg-white p-5 flex gap-3">
          <MessageSquare className="w-5 h-5 text-[#0F2137] shrink-0 mt-0.5" />
          <div>
            <div className="font-display font-semibold text-[#0F2137]">Votre retour compte</div>
            <p className="text-sm text-slate-600 mt-1">
              À la fin de chaque génération, notez et commentez. Ces retours guident les prochaines fonctionnalités.
            </p>
          </div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5 flex gap-3">
          <Shield className="w-5 h-5 text-[#0F2137] shrink-0 mt-0.5" />
          <div>
            <div className="font-display font-semibold text-[#0F2137]">Vos données restent privées</div>
            <p className="text-sm text-slate-600 mt-1">
              Documents traités en mémoire, jamais partagés. Pas de cookies publicitaires.
            </p>
          </div>
        </div>
      </div>

      <p className="text-center text-xs text-slate-400 mt-8 font-mono-tech">
        Le service pourra évoluer vers un modèle payant à la sortie de beta.
      </p>
    </div>
  );
}
